"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputField = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var InputField_styled_1 = require("./InputField.styled");
var loading_spinner_1 = require("@next-components/loading-spinner");
var classnames_1 = require("classnames");
var parts_1 = require("./parts");
var next_common_1 = require("next-common");
var common_types_1 = require("@next-components/common-types");
var bos_icon_1 = require("@next-components/bos-icon");
exports.InputField = function (props) {
    var _a;
    var _b = React.useState(''), value = _b[0], setValue = _b[1];
    var type = typeof props.type === 'string' ? props.type : next_common_1.getInputTagType(props.type);
    var maxLength = (_a = props.maxLength) !== null && _a !== void 0 ? _a : next_common_1.getInputMaxLength(props.type);
    if (props.defaultValue && props.value)
        throw new Error();
    React.useEffect(function () {
        var _a, _b;
        var asString = (_b = (_a = props.defaultValue) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '';
        var formatted = next_common_1.formatInput(asString, props.type, props.decimals).formatted;
        setValue(formatted);
    }, []);
    React.useEffect(function () {
        if (!props.value)
            return;
        var asString = props.value.toString();
        var formatted = next_common_1.formatInput(asString, props.type, props.decimals).formatted;
        setValue(formatted);
    }, [props.value]);
    var onBlur = function (event) {
        onChange(event);
        if (typeof props.onBlur === 'function') {
            props.onBlur(event);
        }
    };
    var onFocus = function (event) {
        if (typeof props.onFocus === 'function') {
            props.onFocus(event);
        }
    };
    var onKeyDown = function (e) {
        if (typeof props.onKeyDown === 'function') {
            props.onKeyDown(e);
        }
        else {
            if (e.which === 13) {
                onSubmit(e);
            }
        }
    };
    var onChange = function (e) {
        var _a;
        var _b = next_common_1.formatInput((_a = e.currentTarget.value) !== null && _a !== void 0 ? _a : '', props.type, props.decimals), formatted = _b.formatted, parsed = _b.parsed;
        setValue(formatted);
        props.onChange && props.onChange(parsed);
    };
    var onSubmit = function (e) {
        var _a;
        var _b = next_common_1.formatInput((_a = e.currentTarget.value) !== null && _a !== void 0 ? _a : '', props.type, props.decimals), formatted = _b.formatted, parsed = _b.parsed;
        setValue(formatted);
        props.onSubmit && props.onSubmit(parsed);
    };
    var commonProps = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (props.id ? { id: props.id } : {})), (props.autoComplete === false ? { autoComplete: 'off' } : {})), { 'aria-placeholder': props.placeholder || null, 'aria-label': props.ariaLabel || null, disabled: props.disabled, maxLength: maxLength, placeholder: props.placeholder || null, value: value,
        onBlur: onBlur,
        onChange: onChange,
        onSubmit: onSubmit,
        onFocus: onFocus,
        onKeyDown: onKeyDown });
    var Loading = function () {
        var _a, _b;
        if (!((_a = props.loading) === null || _a === void 0 ? void 0 : _a.isLoading))
            return null;
        return (React.createElement("span", { className: 'loading-container' },
            React.createElement(loading_spinner_1.LoadingSpinner, { size: ((_b = props.loading) === null || _b === void 0 ? void 0 : _b.size) || 30, variant: loading_spinner_1.SpinnerVariant.DEFAULT })));
    };
    if (props.type === next_common_1.InputType.TEXT_AREA)
        return (React.createElement(InputField_styled_1.InputContainer, { className: props.className || '', site: props.site },
            React.createElement("div", { className: "inputContainer" },
                props.label ? React.createElement("label", { htmlFor: props.id }, props.label) : null,
                React.createElement("textarea", tslib_1.__assign({}, commonProps, { rows: props.rows }),
                    React.createElement(Loading, null)))));
    var classesObject = {
        startAdornmentInput: props.startAdornment,
        endAdornmentInput: props.endAdornment,
        error: !!props.errorMessage,
        validated: props.isValid,
    };
    return (React.createElement(InputField_styled_1.InputContainer, { className: props.className || '', site: props.site },
        React.createElement("div", { className: "inputContainer" },
            props.label ? React.createElement("label", { htmlFor: props.id }, props.label) : null,
            React.createElement("div", { className: 'inputAndIconContainer' },
                React.createElement(parts_1.AdornmentContainer, { adornment: props.startAdornment, position: "start", site: props.site }),
                React.createElement("input", tslib_1.__assign({}, commonProps, { type: type, className: classnames_1.default(classesObject) })),
                React.createElement(parts_1.AdornmentContainer, { adornment: props.endAdornment, position: "end", site: props.site }),
                React.createElement(Loading, null),
                props.site === common_types_1.Site.mercedes && props.withErrorMessage && !props.isValid ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "validation-container" },
                        React.createElement(bos_icon_1.Icon, { icon: "close", className: "error-icon" })))) : null,
                props.site === common_types_1.Site.mercedes && props.isValid ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "validation-container" },
                        React.createElement(bos_icon_1.Icon, { icon: "check", className: "validation-icon" })))) : null)),
        props.withErrorMessage && React.createElement("div", { className: 'errorMessage' }, props.errorMessage)));
};
exports.InputField.defaultProps = {
    defaultValue: '',
    site: common_types_1.Site.bosno,
};
//# sourceMappingURL=InputField.js.map